export default async function getFrameToken(email) {
  let frameToken = null;

  // Pass in the user's email into the token generator
  // This will tag the session in Frame's analytics
  // We split the email into the first/last name fields as it
  // shows up nicer in the dashboard
  const [firstName, lastName] = email.split('@');
  let metadata = {};
  if (email !== firstName) {
    metadata = {
      first_name: firstName,
      // A null value will fall back to the default last name "User",
      // which looks better than "@undefined"
      last_name: lastName ? `@${lastName}` : lastName,
      email,
    };
  }

  const url = process.env.REACT_APP_TOKEN_SERVICE_URL;
  const serviceAuth = process.env.REACT_APP_TOKEN_SERVICE_AUTH;
  if (url === undefined || serviceAuth === undefined) {
    throw new Error('Environment is misconfigured');
  }

  // Send request to the Secure Anonymous Token service
  const options = {
    method: 'POST',
    url,
    headers: {
      authorization: serviceAuth,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(metadata),
  };
  const response = await fetch(url, options);

  // We should get a JSON object back even when the service fails
  const payload = await response.json();
  if (response.status === 200) {
    if ('token' in payload) {
      frameToken = payload.token;
    } else {
      // I hope this never happens 🙀
      throw new Error('No token returned');
    }
  } else if ('message' in payload) {
    // If the service has a message for us, report it directly
    if ('details' in payload) {
      throw new Error(`${payload.message}: ${payload.details}`);
    } else {
      throw new Error(payload.message);
    }
  } else {
    // Generic error otherwise
    throw new Error('Failed to authorise access');
  }

  return frameToken;
}
